import "phaser";
import card from "../model/card.js";
import { CST } from "../CST";

var paused = false;

export class Controller {
  constructor(self) {
    this.self = self;
  }

  randomizeNumber(card) {
    var min = Math.ceil(0);
    var max = Math.floor(45);
    var rndNum = Math.floor(Math.random() * (max - min + 1)) + min;

    return rndNum;
  }
}
